<template>
  <main>
    <div class="container">

      <section class="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
        <h1>404</h1>
        <h2>Такой страницы не существует.</h2>
        <router-link class="btn" to="/">Домашняя</router-link>
        <img src="assets/img/not-found.svg" class="img-fluid py-5" alt="Page Not Found">
      </section>

    </div>
  </main>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>